import { FC, Fragment, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { legalDate, legalDocuments, LegalDocumentId, legalVersion } from '../legal/documents'
import styles from './css/LegalDocument.module.css'

function linkedText(text: string) {
	const pattern = /(https?:\/\/[^\s]+|[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,})/gi
	const parts = text.split(pattern)
	return parts.map((part, index) => {
		if (index % 2 === 0) return part
		const target = part.replace(/[.,;:)]+$/, '')
		return <Fragment key={index}><a href={target.includes('://') ? target : `mailto:${target}`}>{target}</a>{part.slice(target.length)}</Fragment>
	})
}

const LegalDocument: FC<{ document: LegalDocumentId }> = ({ document: documentId }) => {
	const data = legalDocuments[documentId]
	useEffect(() => {
		document.title = `vvTable — ${data.title}`
	}, [data.title])

	return (
		<article className={styles.document} lang='ru'>
			<h1>{data.title}</h1>
			<p className={styles.date}>Редакция от <time dateTime={legalVersion}>{legalDate}</time></p>
			<nav className={styles.links} aria-label='Юридические документы'>
				<Link to='/tos' aria-current={documentId === 'terms' ? 'page' : undefined}>Пользовательское соглашение</Link>
				<Link to='/privacy' aria-current={documentId === 'privacy' ? 'page' : undefined}>Политика конфиденциальности</Link>
				<a href={`/legal/${documentId}-${legalVersion}.txt`} download>Скачать текст</a>
			</nav>
			{data.sections.map((section, index) => (
				<section key={section.heading} id={`legal-section-${index + 1}`} className={styles.section}>
					<h2>{section.heading}</h2>
					{section.paragraphs.map((paragraph, paragraphIndex) => <p key={paragraphIndex}>{linkedText(paragraph)}</p>)}
				</section>
			))}
		</article>
	)
}

export default LegalDocument
